module.exports = __webpack_public_path__ + "static/media/Fishing.svg";